import { COLORS } from '@constants';
import styled, { css } from 'styled-components';

export const OptionCard = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 48px 32px;
    background: ${COLORS.$white};
    border: 2px solid ${({ $isSelected }) => ($isSelected ? COLORS.$pink : COLORS.$gray15Black)};
    border-radius: 8px;
    flex: 1;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        border-color: ${COLORS.$pink};
        box-shadow: 0 2px 8px rgba(218, 23, 129, 0.1);
    }

    ${({ $isSelected }) =>
        $isSelected &&
        css`
            border-color: ${COLORS.$pink};
            box-shadow: 0 2px 8px rgba(218, 23, 129, 0.15);
        `}

    ${({ $disabled }) =>
        $disabled &&
        css`
            opacity: 0.5;
            cursor: not-allowed;
            pointer-events: none;

            &:hover {
                border-color: ${COLORS.$gray15Black};
                box-shadow: none;
            }
        `}
`;

export const OptionContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const OptionTitle = styled.div`
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
    color: ${COLORS.$gray100Black};
`;

export const OptionDescription = styled.div`
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${COLORS.$gray100Black};
`;

export const OptionNote = styled.div`
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: ${COLORS.$gray60Black};
    text-align: right;
`;
